import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import assessmentNameMessagesTpl from '../messages/assessment.name.messages.html';
import tierLevelMessagesTpl from '../messages/assessment.tierLevel.messages.html';
import validator, { name as validatorName } from '../messages/assessment-unique-name.validator.directive';
import controller from './edit-assessment-dialog.controller';
import template from './edit-assessment-dialog.html';

class dialogService {
  getOptions($event, { templates, assessment }) {
    return {
      controller,
      controllerAs: 'editAssessmentDialogVM',
      locals: {
        templates,
        assessment
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.ecat.editAssessmentDialog', [
  alerts,
  ecatDataService,
  loaderService,
  constants,
  ssDialogService,
])
  .directive(validatorName, validator)
  .service('editAssessmentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('assessment.name.messages.html', assessmentNameMessagesTpl);
    $templateCache.put('assessment.tierLevel.messages.html', tierLevelMessagesTpl);
  })
  .name;
